import React from 'react';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { CircularProgress } from '@mui/material';

import scss from './CheckBadge.module.scss';

function CheckBadge({ isChecked = false }) {
  if (!isChecked) {
    return null;
  }

  return (
    <div role='img' className={scss.badge}>
      <CircularProgress variant='determinate' value={100} thickness={4} className={scss.ring} />
      <CheckRoundedIcon className={scss.check} />
    </div>
  );
}

export default CheckBadge;
